"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DDB - Taxonomy Service
 * Set from Package Json
 *
 * The version of the OpenAPI document: 0.14.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyApi = exports.TaxonomyApiFactory = exports.TaxonomyApiFp = exports.TaxonomyApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * TaxonomyApi - axios parameter creator
 * @export
 */
var TaxonomyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Delete an item type from the database by id. Note - deleting a global item type requires Admin privileges.
         * @summary Soft delete item type by id
         * @param {object} itemTypeId the id of the item type to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemType: function (itemTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'itemTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteItemType', 'itemTypeId', itemTypeId);
                            localVarPath = "/item_types/{item_type_id}"
                                .replace("{".concat("item_type_id", "}"), encodeURIComponent(String(itemTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Soft-deletes options of the given item_type
         * @summary Deletes options for given item_type - Note - deleting options for a global item type requires Admin privileges.
         * @param {object} itemTypeId Id of item_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOptions: function (itemTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'itemTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteOptions', 'itemTypeId', itemTypeId);
                            localVarPath = "/item_types/{item_type_id}/options"
                                .replace("{".concat("item_type_id", "}"), encodeURIComponent(String(itemTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all asset type groups contained within the database
         * @summary Finds all asset_type_groups within the database
         * @param {Array<string>} [assetTypeGroupId] List of asset_type_group_ids to search by
         * @param {'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAssetTypeGroups: function (assetTypeGroupId, sortBy, order, pageLimit, after, before, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/asset_type_groups";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (assetTypeGroupId) {
                                localVarQueryParameter['asset_type_group_id'] = assetTypeGroupId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all asset types contained within the database
         * @summary Finds all asset_types within the database
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {Array<string>} [assetTypeId] List of asset_type_ids to search by
         * @param {Array<string>} [parentAssetId] List of parent_asset_ids to search by
         * @param {Array<string>} [assetTypeGroupId] List of asset_type_group_ids to search by
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAssetTypes: function (projectId, assetTypeId, parentAssetId, assetTypeGroupId, sortBy, order, pageLimit, after, before, search, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/asset_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (projectId) {
                                localVarQueryParameter['project_id'] = projectId;
                            }
                            if (assetTypeId) {
                                localVarQueryParameter['asset_type_id'] = assetTypeId;
                            }
                            if (parentAssetId) {
                                localVarQueryParameter['parent_asset_id'] = parentAssetId;
                            }
                            if (assetTypeGroupId) {
                                localVarQueryParameter['asset_type_group_id'] = assetTypeGroupId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all item types
         * @summary Get all item types
         * @param {Array<string>} [itemTypeId] List of item_types_id to search by
         * @param {Array<string>} [parameterTypeId] list of parameter_type_ids to search by
         * @param {object} [assetTypeId] asset_type_id to search by
         * @param {object} [notAssetTypeId] asset_type_id to exclude
         * @param {object} [assetSubTypeId] asset_sub_type_id to search by
         * @param {object} [notAssetSubTypeId] asset_sub_type_id to exclude
         * @param {boolean} [showGlobal] Flags whether to include global item_types in the response.
         * @param {boolean} [showLocal] Flags whether to include non-global item_types that are scoped to a project.
         * @param {string} [scopeId] The ID of the project to filter non-global item_types by. The response will include non-global item_types that are scoped to the project specified in the query. show_local must be set to true to show results of this query.
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {'created_at' | 'parameter_type_name'} [sortBy] created_at sorts by creation date of the parameter and parameter_type_name sorts by the name of the revisions parameter_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllItemTypes: function (itemTypeId, parameterTypeId, assetTypeId, notAssetTypeId, assetSubTypeId, notAssetSubTypeId, showGlobal, showLocal, scopeId, order, pageLimit, after, before, sortBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/item_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (itemTypeId) {
                                localVarQueryParameter['item_type_id'] = itemTypeId;
                            }
                            if (parameterTypeId) {
                                localVarQueryParameter['parameter_type_id'] = parameterTypeId;
                            }
                            if (assetTypeId !== undefined) {
                                localVarQueryParameter['asset_type_id'] = assetTypeId;
                            }
                            if (notAssetTypeId !== undefined) {
                                localVarQueryParameter['not_asset_type_id'] = notAssetTypeId;
                            }
                            if (assetSubTypeId !== undefined) {
                                localVarQueryParameter['asset_sub_type_id'] = assetSubTypeId;
                            }
                            if (notAssetSubTypeId !== undefined) {
                                localVarQueryParameter['not_asset_sub_type_id'] = notAssetSubTypeId;
                            }
                            if (showGlobal !== undefined) {
                                localVarQueryParameter['show_global'] = showGlobal;
                            }
                            if (showLocal !== undefined) {
                                localVarQueryParameter['show_local'] = showLocal;
                            }
                            if (scopeId !== undefined) {
                                localVarQueryParameter['scope_id'] = scopeId;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all parameter types contained within the database
         * @summary Finds all parameter_types within the database
         * @param {object} [notAssetId] The ID of the asset to filter parameter_types by , will only return parameter_types that are not attached to the given asset_id
         * @param {object} [projectId] The ID of the project to filter parameter_types by, will only return parameter_types that have an existing parameter instance on the given project_id
         * @param {object} [notProjectId] The ID of the project to filter parameter_types by , will only return parameter_types that do not have an existing parameter instance on the given project_id
         * @param {object} [assetTypeId] The ID of the asset type to filter parameter_types by , will only return parameter_types that are attached to the given asset_type. An empty asset_type_id query will return parameter_types that have no asset_type associated with them (i.e. project level parameters)
         * @param {object} [assetSubTypeId] The ID of the asset sub type to filter parameter_types by , will only return parameter_types that are attached to the given asset_sub_type. An empty asset_sub_type_id query will return parameter_types that have no asset_sub_type associated with them (i.e. of asset type with no sub types or project level parameters)
         * @param {Array<string>} [parameterTypeId] Query by an array of parameter_type_id\&#39;s
         * @param {boolean} [showGlobal] Flags whether to include global parameter types in the response.
         * @param {boolean} [showLocal] Flags whether to include non-global parameter_types that are scoped to a project.
         * @param {string} [scopeId] The ID of the project to filter non-global parameter_types by. The response will include non-global parameter_types that are scoped to the project specified in the query. show_local must be set to true to show results of this query.
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParameterTypes: function (notAssetId, projectId, notProjectId, assetTypeId, assetSubTypeId, parameterTypeId, showGlobal, showLocal, scopeId, sortBy, assetId, order, pageLimit, after, before, search, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/parameter_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (notAssetId !== undefined) {
                                localVarQueryParameter['not_asset_id'] = notAssetId;
                            }
                            if (projectId !== undefined) {
                                localVarQueryParameter['project_id'] = projectId;
                            }
                            if (notProjectId !== undefined) {
                                localVarQueryParameter['not_project_id'] = notProjectId;
                            }
                            if (assetTypeId !== undefined) {
                                localVarQueryParameter['asset_type_id'] = assetTypeId;
                            }
                            if (assetSubTypeId !== undefined) {
                                localVarQueryParameter['asset_sub_type_id'] = assetSubTypeId;
                            }
                            if (parameterTypeId) {
                                localVarQueryParameter['parameter_type_id'] = parameterTypeId;
                            }
                            if (showGlobal !== undefined) {
                                localVarQueryParameter['show_global'] = showGlobal;
                            }
                            if (showLocal !== undefined) {
                                localVarQueryParameter['show_local'] = showLocal;
                            }
                            if (scopeId !== undefined) {
                                localVarQueryParameter['scope_id'] = scopeId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (assetId) {
                                localVarQueryParameter['asset_id'] = assetId;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all units systems contained within the database. Unit systems are unique by name.
         * @summary Finds all unit systems within the database
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUnitSystems: function (sortBy, order, pageLimit, after, before, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/unit_systems";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all units types contained within the database. Unit types are unique by name. Note - the available unit types for a parameter type should be obtained from the parameter_types endpoint.
         * @summary Finds all unit types within the database
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {Array<string>} [unitTypeId] Filters the unit types to those associated with the provided unit type ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUnitTypes: function (sortBy, order, pageLimit, after, before, unitTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/unit_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (unitTypeId) {
                                localVarQueryParameter['unit_type_id'] = unitTypeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all units contained within the database. Units are unique by name. Note - the available units for a parameter type should be obtained from the parameter_types endpoint.
         * @summary Finds all units within the database
         * @param {Array<string>} [parameterTypeId] Filters the parameters to those associated with the provided parameter type ids
         * @param {'created_at' | 'symbol'} [sortBy] Field by which to sort projects by
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {Array<string>} [unitId] Filters the units to those associated with the provided unit ids
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUnits: function (parameterTypeId, sortBy, assetId, projectId, unitId, order, pageLimit, after, before, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/units";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (parameterTypeId) {
                                localVarQueryParameter['parameter_type_id'] = parameterTypeId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (assetId) {
                                localVarQueryParameter['asset_id'] = assetId;
                            }
                            if (projectId) {
                                localVarQueryParameter['project_id'] = projectId;
                            }
                            if (unitId) {
                                localVarQueryParameter['unit_id'] = unitId;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all asset sub types related to the specified asset type contained within the database
         * @summary Finds all asset_sub_types related to the asset_type_id
         * @param {object} assetTypeId Asset_type_id to search by
         * @param {Array<string>} [assetSubTypeId] The asset_sub_type_id to search by
         * @param {object} [parentAssetSubTypeId] Unique ID of the asset sub type\&#39;s parent asset sub type (for example the variable temperature sub-system would have a parent of the hot water system)
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort asset_sub_types by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetSubTypes: function (assetTypeId, assetSubTypeId, parentAssetSubTypeId, sortBy, order, pageLimit, after, before, search, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'assetTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('getAssetSubTypes', 'assetTypeId', assetTypeId);
                            localVarPath = "/asset_types/{asset_type_id}/asset_sub_types"
                                .replace("{".concat("asset_type_id", "}"), encodeURIComponent(String(assetTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (assetSubTypeId) {
                                localVarQueryParameter['asset_sub_type_id'] = assetSubTypeId;
                            }
                            if (parentAssetSubTypeId !== undefined) {
                                localVarQueryParameter['parent_asset_sub_type_id'] = parentAssetSubTypeId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all id, name, asset_type_id, and parent_asset_sub_type_id of  asset sub types related to the specified asset sub type ids contained within the database
         * @summary Finds all asset_sub_types associated with provided asset_sub_type_id
         * @param {Array<string>} [assetSubTypeId] The asset_sub_type_ids to search by
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort asset_sub_types by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetSubTypesRef: function (assetSubTypeId, sortBy, order, pageLimit, after, before, search, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/asset_sub_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (assetSubTypeId) {
                                localVarQueryParameter['asset_sub_type_id'] = assetSubTypeId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns parent, children, grandchildren etc. asset types contained within the database
         * @summary Gets an asset type tree by asset_type_id within the database
         * @param {Array<string>} assetTypeId List of asset_type_ids to query by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetTypeTree: function (assetTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'assetTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('getAssetTypeTree', 'assetTypeId', assetTypeId);
                            localVarPath = "/asset_type_tree";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (assetTypeId) {
                                localVarQueryParameter['asset_type_id'] = assetTypeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Lists all options for an item type
         * @summary Get all options for an item type
         * @param {object} itemTypeId Id of item_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptions: function (itemTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'itemTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('getOptions', 'itemTypeId', itemTypeId);
                            localVarPath = "/item_types/{item_type_id}/options"
                                .replace("{".concat("item_type_id", "}"), encodeURIComponent(String(itemTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all parameter type by ID from the database
         * @summary Finds all parameter_type by ID
         * @param {object} parameterTypeId The ID of the parameter type to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameterType: function (parameterTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('getParameterType', 'parameterTypeId', parameterTypeId);
                            localVarPath = "/parameter_types/{parameter_type_id}"
                                .replace("{".concat("parameter_type_id", "}"), encodeURIComponent(String(parameterTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all units relating to the specified unit_type_id within the database. Units are grouped by their unit system.
         * @summary Finds a unit type\'s corresponding units
         * @param {object} unitTypeId Unique ID for a single unit type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitType: function (unitTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'unitTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('getUnitType', 'unitTypeId', unitTypeId);
                            localVarPath = "/unit_types/{unit_type_id}"
                                .replace("{".concat("unit_type_id", "}"), encodeURIComponent(String(unitTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update an existing asset type. Note - requires Admin privileges.
         * @summary Patch an existing asset type (Application Admin only)
         * @param {object} assetTypeId The ID of the asset type to search
         * @param {PatchAssetTypeBody} patchAssetTypeBody Updates for the asset type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAssetType: function (assetTypeId, patchAssetTypeBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'assetTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('patchAssetType', 'assetTypeId', assetTypeId);
                            // verify required parameter 'patchAssetTypeBody' is not null or undefined
                            (0, common_1.assertParamExists)('patchAssetType', 'patchAssetTypeBody', patchAssetTypeBody);
                            localVarPath = "/asset_types/{asset_type_id}"
                                .replace("{".concat("asset_type_id", "}"), encodeURIComponent(String(assetTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchAssetTypeBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update an existing parameter type. Note - updating global parameter types (scope = null) requires Admin privileges.
         * @summary Patch existing parameter type
         * @param {object} parameterTypeId The ID of the parameter type to search
         * @param {PatchParameterTypeBody} patchParameterTypeBody Updates for parameter type. Note - updating the default unit  will also update the associated unit type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchParameterType: function (parameterTypeId, patchParameterTypeBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('patchParameterType', 'parameterTypeId', parameterTypeId);
                            // verify required parameter 'patchParameterTypeBody' is not null or undefined
                            (0, common_1.assertParamExists)('patchParameterType', 'patchParameterTypeBody', patchParameterTypeBody);
                            localVarPath = "/parameter_types/{parameter_type_id}"
                                .replace("{".concat("parameter_type_id", "}"), encodeURIComponent(String(parameterTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchParameterTypeBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates new asset sub types. Note - requires Admin privileges.
         * @summary Creates new asset sub types (Application Admin only)
         * @param {object} assetTypeId Asset_type_ids to search by
         * @param {PostAssetSubTypesBody} postAssetSubTypesBody New asset sub type details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssetSubTypes: function (assetTypeId, postAssetSubTypesBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'assetTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('postAssetSubTypes', 'assetTypeId', assetTypeId);
                            // verify required parameter 'postAssetSubTypesBody' is not null or undefined
                            (0, common_1.assertParamExists)('postAssetSubTypes', 'postAssetSubTypesBody', postAssetSubTypesBody);
                            localVarPath = "/asset_types/{asset_type_id}/asset_sub_types"
                                .replace("{".concat("asset_type_id", "}"), encodeURIComponent(String(assetTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postAssetSubTypesBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates an asset type group. Note - requires Admin privileges.
         * @summary Create a new asset type group (Application Admin only)
         * @param {PostAssetTypeGroupsBody} postAssetTypeGroupsBody New asset type details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssetTypeGroups: function (postAssetTypeGroupsBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postAssetTypeGroupsBody' is not null or undefined
                            (0, common_1.assertParamExists)('postAssetTypeGroups', 'postAssetTypeGroupsBody', postAssetTypeGroupsBody);
                            localVarPath = "/asset_type_groups";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postAssetTypeGroupsBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates an asset type. Note - requires Admin privileges.
         * @summary Create a new asset type (Application Admin only)
         * @param {PostAssetTypesBody} postAssetTypesBody New asset type details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssetTypes: function (postAssetTypesBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postAssetTypesBody' is not null or undefined
                            (0, common_1.assertParamExists)('postAssetTypes', 'postAssetTypesBody', postAssetTypesBody);
                            localVarPath = "/asset_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postAssetTypesBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates an item type.  Note - creating a global item type requires Admin privileges.
         * @summary Create a new item type
         * @param {PostItemTypesBody} postItemTypesBody New item type details. You must specify the asset_type_id if posting  with an asset_sub_type_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postItemTypes: function (postItemTypesBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postItemTypesBody' is not null or undefined
                            (0, common_1.assertParamExists)('postItemTypes', 'postItemTypesBody', postItemTypesBody);
                            localVarPath = "/item_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postItemTypesBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates new parameter types. Note - creating global parameter types (scope = null) requires Admin privileges.
         * @summary Creates new parameter types
         * @param {PostParameterTypesBody} postParameterTypesBody New parameter type details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postParameterTypes: function (postParameterTypesBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postParameterTypesBody' is not null or undefined
                            (0, common_1.assertParamExists)('postParameterTypes', 'postParameterTypesBody', postParameterTypesBody);
                            localVarPath = "/parameter_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postParameterTypesBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Posts new unit types. This can only be done by an administrator
         * @summary Create new units types. Note - requires Admin privileges.
         * @param {PostUnitTypesBody} postUnitTypesBody Unit types to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUnitTypes: function (postUnitTypesBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postUnitTypesBody' is not null or undefined
                            (0, common_1.assertParamExists)('postUnitTypes', 'postUnitTypesBody', postUnitTypesBody);
                            localVarPath = "/unit_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postUnitTypesBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Posts new units. This can only be done by an administrator
         * @summary Create new units. Note - requires Admin privileges.
         * @param {PostUnitsBody} postUnitsBody Units to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUnits: function (postUnitsBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postUnitsBody' is not null or undefined
                            (0, common_1.assertParamExists)('postUnits', 'postUnitsBody', postUnitsBody);
                            localVarPath = "/units";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postUnitsBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Overwrites options for a given item_type by deleting the existing and adding new
         * @summary Sets options for given item_type - Note - creating options for a global item type requires Admin privileges.
         * @param {object} itemTypeId Id of item_type
         * @param {PutOptionsRequest} putOptionsRequest List of values (each value is an object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOptions: function (itemTypeId, putOptionsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'itemTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('putOptions', 'itemTypeId', itemTypeId);
                            // verify required parameter 'putOptionsRequest' is not null or undefined
                            (0, common_1.assertParamExists)('putOptions', 'putOptionsRequest', putOptionsRequest);
                            localVarPath = "/item_types/{item_type_id}/options"
                                .replace("{".concat("item_type_id", "}"), encodeURIComponent(String(itemTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(putOptionsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TaxonomyApiAxiosParamCreator = TaxonomyApiAxiosParamCreator;
/**
 * TaxonomyApi - functional programming interface
 * @export
 */
var TaxonomyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TaxonomyApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete an item type from the database by id. Note - deleting a global item type requires Admin privileges.
         * @summary Soft delete item type by id
         * @param {object} itemTypeId the id of the item type to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemType: function (itemTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteItemType(itemTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Soft-deletes options of the given item_type
         * @summary Deletes options for given item_type - Note - deleting options for a global item type requires Admin privileges.
         * @param {object} itemTypeId Id of item_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOptions: function (itemTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteOptions(itemTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all asset type groups contained within the database
         * @summary Finds all asset_type_groups within the database
         * @param {Array<string>} [assetTypeGroupId] List of asset_type_group_ids to search by
         * @param {'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAssetTypeGroups: function (assetTypeGroupId, sortBy, order, pageLimit, after, before, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllAssetTypeGroups(assetTypeGroupId, sortBy, order, pageLimit, after, before, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all asset types contained within the database
         * @summary Finds all asset_types within the database
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {Array<string>} [assetTypeId] List of asset_type_ids to search by
         * @param {Array<string>} [parentAssetId] List of parent_asset_ids to search by
         * @param {Array<string>} [assetTypeGroupId] List of asset_type_group_ids to search by
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAssetTypes: function (projectId, assetTypeId, parentAssetId, assetTypeGroupId, sortBy, order, pageLimit, after, before, search, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllAssetTypes(projectId, assetTypeId, parentAssetId, assetTypeGroupId, sortBy, order, pageLimit, after, before, search, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all item types
         * @summary Get all item types
         * @param {Array<string>} [itemTypeId] List of item_types_id to search by
         * @param {Array<string>} [parameterTypeId] list of parameter_type_ids to search by
         * @param {object} [assetTypeId] asset_type_id to search by
         * @param {object} [notAssetTypeId] asset_type_id to exclude
         * @param {object} [assetSubTypeId] asset_sub_type_id to search by
         * @param {object} [notAssetSubTypeId] asset_sub_type_id to exclude
         * @param {boolean} [showGlobal] Flags whether to include global item_types in the response.
         * @param {boolean} [showLocal] Flags whether to include non-global item_types that are scoped to a project.
         * @param {string} [scopeId] The ID of the project to filter non-global item_types by. The response will include non-global item_types that are scoped to the project specified in the query. show_local must be set to true to show results of this query.
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {'created_at' | 'parameter_type_name'} [sortBy] created_at sorts by creation date of the parameter and parameter_type_name sorts by the name of the revisions parameter_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllItemTypes: function (itemTypeId, parameterTypeId, assetTypeId, notAssetTypeId, assetSubTypeId, notAssetSubTypeId, showGlobal, showLocal, scopeId, order, pageLimit, after, before, sortBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllItemTypes(itemTypeId, parameterTypeId, assetTypeId, notAssetTypeId, assetSubTypeId, notAssetSubTypeId, showGlobal, showLocal, scopeId, order, pageLimit, after, before, sortBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all parameter types contained within the database
         * @summary Finds all parameter_types within the database
         * @param {object} [notAssetId] The ID of the asset to filter parameter_types by , will only return parameter_types that are not attached to the given asset_id
         * @param {object} [projectId] The ID of the project to filter parameter_types by, will only return parameter_types that have an existing parameter instance on the given project_id
         * @param {object} [notProjectId] The ID of the project to filter parameter_types by , will only return parameter_types that do not have an existing parameter instance on the given project_id
         * @param {object} [assetTypeId] The ID of the asset type to filter parameter_types by , will only return parameter_types that are attached to the given asset_type. An empty asset_type_id query will return parameter_types that have no asset_type associated with them (i.e. project level parameters)
         * @param {object} [assetSubTypeId] The ID of the asset sub type to filter parameter_types by , will only return parameter_types that are attached to the given asset_sub_type. An empty asset_sub_type_id query will return parameter_types that have no asset_sub_type associated with them (i.e. of asset type with no sub types or project level parameters)
         * @param {Array<string>} [parameterTypeId] Query by an array of parameter_type_id\&#39;s
         * @param {boolean} [showGlobal] Flags whether to include global parameter types in the response.
         * @param {boolean} [showLocal] Flags whether to include non-global parameter_types that are scoped to a project.
         * @param {string} [scopeId] The ID of the project to filter non-global parameter_types by. The response will include non-global parameter_types that are scoped to the project specified in the query. show_local must be set to true to show results of this query.
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParameterTypes: function (notAssetId, projectId, notProjectId, assetTypeId, assetSubTypeId, parameterTypeId, showGlobal, showLocal, scopeId, sortBy, assetId, order, pageLimit, after, before, search, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllParameterTypes(notAssetId, projectId, notProjectId, assetTypeId, assetSubTypeId, parameterTypeId, showGlobal, showLocal, scopeId, sortBy, assetId, order, pageLimit, after, before, search, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all units systems contained within the database. Unit systems are unique by name.
         * @summary Finds all unit systems within the database
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUnitSystems: function (sortBy, order, pageLimit, after, before, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllUnitSystems(sortBy, order, pageLimit, after, before, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all units types contained within the database. Unit types are unique by name. Note - the available unit types for a parameter type should be obtained from the parameter_types endpoint.
         * @summary Finds all unit types within the database
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {Array<string>} [unitTypeId] Filters the unit types to those associated with the provided unit type ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUnitTypes: function (sortBy, order, pageLimit, after, before, unitTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllUnitTypes(sortBy, order, pageLimit, after, before, unitTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all units contained within the database. Units are unique by name. Note - the available units for a parameter type should be obtained from the parameter_types endpoint.
         * @summary Finds all units within the database
         * @param {Array<string>} [parameterTypeId] Filters the parameters to those associated with the provided parameter type ids
         * @param {'created_at' | 'symbol'} [sortBy] Field by which to sort projects by
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {Array<string>} [unitId] Filters the units to those associated with the provided unit ids
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUnits: function (parameterTypeId, sortBy, assetId, projectId, unitId, order, pageLimit, after, before, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllUnits(parameterTypeId, sortBy, assetId, projectId, unitId, order, pageLimit, after, before, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all asset sub types related to the specified asset type contained within the database
         * @summary Finds all asset_sub_types related to the asset_type_id
         * @param {object} assetTypeId Asset_type_id to search by
         * @param {Array<string>} [assetSubTypeId] The asset_sub_type_id to search by
         * @param {object} [parentAssetSubTypeId] Unique ID of the asset sub type\&#39;s parent asset sub type (for example the variable temperature sub-system would have a parent of the hot water system)
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort asset_sub_types by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetSubTypes: function (assetTypeId, assetSubTypeId, parentAssetSubTypeId, sortBy, order, pageLimit, after, before, search, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAssetSubTypes(assetTypeId, assetSubTypeId, parentAssetSubTypeId, sortBy, order, pageLimit, after, before, search, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all id, name, asset_type_id, and parent_asset_sub_type_id of  asset sub types related to the specified asset sub type ids contained within the database
         * @summary Finds all asset_sub_types associated with provided asset_sub_type_id
         * @param {Array<string>} [assetSubTypeId] The asset_sub_type_ids to search by
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort asset_sub_types by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetSubTypesRef: function (assetSubTypeId, sortBy, order, pageLimit, after, before, search, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAssetSubTypesRef(assetSubTypeId, sortBy, order, pageLimit, after, before, search, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns parent, children, grandchildren etc. asset types contained within the database
         * @summary Gets an asset type tree by asset_type_id within the database
         * @param {Array<string>} assetTypeId List of asset_type_ids to query by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetTypeTree: function (assetTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAssetTypeTree(assetTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Lists all options for an item type
         * @summary Get all options for an item type
         * @param {object} itemTypeId Id of item_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptions: function (itemTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOptions(itemTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all parameter type by ID from the database
         * @summary Finds all parameter_type by ID
         * @param {object} parameterTypeId The ID of the parameter type to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameterType: function (parameterTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getParameterType(parameterTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all units relating to the specified unit_type_id within the database. Units are grouped by their unit system.
         * @summary Finds a unit type\'s corresponding units
         * @param {object} unitTypeId Unique ID for a single unit type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitType: function (unitTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUnitType(unitTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update an existing asset type. Note - requires Admin privileges.
         * @summary Patch an existing asset type (Application Admin only)
         * @param {object} assetTypeId The ID of the asset type to search
         * @param {PatchAssetTypeBody} patchAssetTypeBody Updates for the asset type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAssetType: function (assetTypeId, patchAssetTypeBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchAssetType(assetTypeId, patchAssetTypeBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update an existing parameter type. Note - updating global parameter types (scope = null) requires Admin privileges.
         * @summary Patch existing parameter type
         * @param {object} parameterTypeId The ID of the parameter type to search
         * @param {PatchParameterTypeBody} patchParameterTypeBody Updates for parameter type. Note - updating the default unit  will also update the associated unit type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchParameterType: function (parameterTypeId, patchParameterTypeBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchParameterType(parameterTypeId, patchParameterTypeBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates new asset sub types. Note - requires Admin privileges.
         * @summary Creates new asset sub types (Application Admin only)
         * @param {object} assetTypeId Asset_type_ids to search by
         * @param {PostAssetSubTypesBody} postAssetSubTypesBody New asset sub type details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssetSubTypes: function (assetTypeId, postAssetSubTypesBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postAssetSubTypes(assetTypeId, postAssetSubTypesBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates an asset type group. Note - requires Admin privileges.
         * @summary Create a new asset type group (Application Admin only)
         * @param {PostAssetTypeGroupsBody} postAssetTypeGroupsBody New asset type details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssetTypeGroups: function (postAssetTypeGroupsBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postAssetTypeGroups(postAssetTypeGroupsBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates an asset type. Note - requires Admin privileges.
         * @summary Create a new asset type (Application Admin only)
         * @param {PostAssetTypesBody} postAssetTypesBody New asset type details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssetTypes: function (postAssetTypesBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postAssetTypes(postAssetTypesBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates an item type.  Note - creating a global item type requires Admin privileges.
         * @summary Create a new item type
         * @param {PostItemTypesBody} postItemTypesBody New item type details. You must specify the asset_type_id if posting  with an asset_sub_type_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postItemTypes: function (postItemTypesBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postItemTypes(postItemTypesBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates new parameter types. Note - creating global parameter types (scope = null) requires Admin privileges.
         * @summary Creates new parameter types
         * @param {PostParameterTypesBody} postParameterTypesBody New parameter type details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postParameterTypes: function (postParameterTypesBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postParameterTypes(postParameterTypesBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Posts new unit types. This can only be done by an administrator
         * @summary Create new units types. Note - requires Admin privileges.
         * @param {PostUnitTypesBody} postUnitTypesBody Unit types to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUnitTypes: function (postUnitTypesBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postUnitTypes(postUnitTypesBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Posts new units. This can only be done by an administrator
         * @summary Create new units. Note - requires Admin privileges.
         * @param {PostUnitsBody} postUnitsBody Units to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUnits: function (postUnitsBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postUnits(postUnitsBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Overwrites options for a given item_type by deleting the existing and adding new
         * @summary Sets options for given item_type - Note - creating options for a global item type requires Admin privileges.
         * @param {object} itemTypeId Id of item_type
         * @param {PutOptionsRequest} putOptionsRequest List of values (each value is an object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOptions: function (itemTypeId, putOptionsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.putOptions(itemTypeId, putOptionsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TaxonomyApiFp = TaxonomyApiFp;
/**
 * TaxonomyApi - factory interface
 * @export
 */
var TaxonomyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TaxonomyApiFp)(configuration);
    return {
        /**
         * Delete an item type from the database by id. Note - deleting a global item type requires Admin privileges.
         * @summary Soft delete item type by id
         * @param {object} itemTypeId the id of the item type to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemType: function (itemTypeId, options) {
            return localVarFp.deleteItemType(itemTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Soft-deletes options of the given item_type
         * @summary Deletes options for given item_type - Note - deleting options for a global item type requires Admin privileges.
         * @param {object} itemTypeId Id of item_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOptions: function (itemTypeId, options) {
            return localVarFp.deleteOptions(itemTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all asset type groups contained within the database
         * @summary Finds all asset_type_groups within the database
         * @param {Array<string>} [assetTypeGroupId] List of asset_type_group_ids to search by
         * @param {'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAssetTypeGroups: function (assetTypeGroupId, sortBy, order, pageLimit, after, before, options) {
            return localVarFp.getAllAssetTypeGroups(assetTypeGroupId, sortBy, order, pageLimit, after, before, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all asset types contained within the database
         * @summary Finds all asset_types within the database
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {Array<string>} [assetTypeId] List of asset_type_ids to search by
         * @param {Array<string>} [parentAssetId] List of parent_asset_ids to search by
         * @param {Array<string>} [assetTypeGroupId] List of asset_type_group_ids to search by
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAssetTypes: function (projectId, assetTypeId, parentAssetId, assetTypeGroupId, sortBy, order, pageLimit, after, before, search, options) {
            return localVarFp.getAllAssetTypes(projectId, assetTypeId, parentAssetId, assetTypeGroupId, sortBy, order, pageLimit, after, before, search, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all item types
         * @summary Get all item types
         * @param {Array<string>} [itemTypeId] List of item_types_id to search by
         * @param {Array<string>} [parameterTypeId] list of parameter_type_ids to search by
         * @param {object} [assetTypeId] asset_type_id to search by
         * @param {object} [notAssetTypeId] asset_type_id to exclude
         * @param {object} [assetSubTypeId] asset_sub_type_id to search by
         * @param {object} [notAssetSubTypeId] asset_sub_type_id to exclude
         * @param {boolean} [showGlobal] Flags whether to include global item_types in the response.
         * @param {boolean} [showLocal] Flags whether to include non-global item_types that are scoped to a project.
         * @param {string} [scopeId] The ID of the project to filter non-global item_types by. The response will include non-global item_types that are scoped to the project specified in the query. show_local must be set to true to show results of this query.
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {'created_at' | 'parameter_type_name'} [sortBy] created_at sorts by creation date of the parameter and parameter_type_name sorts by the name of the revisions parameter_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllItemTypes: function (itemTypeId, parameterTypeId, assetTypeId, notAssetTypeId, assetSubTypeId, notAssetSubTypeId, showGlobal, showLocal, scopeId, order, pageLimit, after, before, sortBy, options) {
            return localVarFp.getAllItemTypes(itemTypeId, parameterTypeId, assetTypeId, notAssetTypeId, assetSubTypeId, notAssetSubTypeId, showGlobal, showLocal, scopeId, order, pageLimit, after, before, sortBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all parameter types contained within the database
         * @summary Finds all parameter_types within the database
         * @param {object} [notAssetId] The ID of the asset to filter parameter_types by , will only return parameter_types that are not attached to the given asset_id
         * @param {object} [projectId] The ID of the project to filter parameter_types by, will only return parameter_types that have an existing parameter instance on the given project_id
         * @param {object} [notProjectId] The ID of the project to filter parameter_types by , will only return parameter_types that do not have an existing parameter instance on the given project_id
         * @param {object} [assetTypeId] The ID of the asset type to filter parameter_types by , will only return parameter_types that are attached to the given asset_type. An empty asset_type_id query will return parameter_types that have no asset_type associated with them (i.e. project level parameters)
         * @param {object} [assetSubTypeId] The ID of the asset sub type to filter parameter_types by , will only return parameter_types that are attached to the given asset_sub_type. An empty asset_sub_type_id query will return parameter_types that have no asset_sub_type associated with them (i.e. of asset type with no sub types or project level parameters)
         * @param {Array<string>} [parameterTypeId] Query by an array of parameter_type_id\&#39;s
         * @param {boolean} [showGlobal] Flags whether to include global parameter types in the response.
         * @param {boolean} [showLocal] Flags whether to include non-global parameter_types that are scoped to a project.
         * @param {string} [scopeId] The ID of the project to filter non-global parameter_types by. The response will include non-global parameter_types that are scoped to the project specified in the query. show_local must be set to true to show results of this query.
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParameterTypes: function (notAssetId, projectId, notProjectId, assetTypeId, assetSubTypeId, parameterTypeId, showGlobal, showLocal, scopeId, sortBy, assetId, order, pageLimit, after, before, search, options) {
            return localVarFp.getAllParameterTypes(notAssetId, projectId, notProjectId, assetTypeId, assetSubTypeId, parameterTypeId, showGlobal, showLocal, scopeId, sortBy, assetId, order, pageLimit, after, before, search, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all units systems contained within the database. Unit systems are unique by name.
         * @summary Finds all unit systems within the database
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUnitSystems: function (sortBy, order, pageLimit, after, before, options) {
            return localVarFp.getAllUnitSystems(sortBy, order, pageLimit, after, before, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all units types contained within the database. Unit types are unique by name. Note - the available unit types for a parameter type should be obtained from the parameter_types endpoint.
         * @summary Finds all unit types within the database
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {Array<string>} [unitTypeId] Filters the unit types to those associated with the provided unit type ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUnitTypes: function (sortBy, order, pageLimit, after, before, unitTypeId, options) {
            return localVarFp.getAllUnitTypes(sortBy, order, pageLimit, after, before, unitTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all units contained within the database. Units are unique by name. Note - the available units for a parameter type should be obtained from the parameter_types endpoint.
         * @summary Finds all units within the database
         * @param {Array<string>} [parameterTypeId] Filters the parameters to those associated with the provided parameter type ids
         * @param {'created_at' | 'symbol'} [sortBy] Field by which to sort projects by
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {Array<string>} [unitId] Filters the units to those associated with the provided unit ids
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUnits: function (parameterTypeId, sortBy, assetId, projectId, unitId, order, pageLimit, after, before, options) {
            return localVarFp.getAllUnits(parameterTypeId, sortBy, assetId, projectId, unitId, order, pageLimit, after, before, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all asset sub types related to the specified asset type contained within the database
         * @summary Finds all asset_sub_types related to the asset_type_id
         * @param {object} assetTypeId Asset_type_id to search by
         * @param {Array<string>} [assetSubTypeId] The asset_sub_type_id to search by
         * @param {object} [parentAssetSubTypeId] Unique ID of the asset sub type\&#39;s parent asset sub type (for example the variable temperature sub-system would have a parent of the hot water system)
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort asset_sub_types by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetSubTypes: function (assetTypeId, assetSubTypeId, parentAssetSubTypeId, sortBy, order, pageLimit, after, before, search, options) {
            return localVarFp.getAssetSubTypes(assetTypeId, assetSubTypeId, parentAssetSubTypeId, sortBy, order, pageLimit, after, before, search, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all id, name, asset_type_id, and parent_asset_sub_type_id of  asset sub types related to the specified asset sub type ids contained within the database
         * @summary Finds all asset_sub_types associated with provided asset_sub_type_id
         * @param {Array<string>} [assetSubTypeId] The asset_sub_type_ids to search by
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort asset_sub_types by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetSubTypesRef: function (assetSubTypeId, sortBy, order, pageLimit, after, before, search, options) {
            return localVarFp.getAssetSubTypesRef(assetSubTypeId, sortBy, order, pageLimit, after, before, search, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns parent, children, grandchildren etc. asset types contained within the database
         * @summary Gets an asset type tree by asset_type_id within the database
         * @param {Array<string>} assetTypeId List of asset_type_ids to query by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetTypeTree: function (assetTypeId, options) {
            return localVarFp.getAssetTypeTree(assetTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Lists all options for an item type
         * @summary Get all options for an item type
         * @param {object} itemTypeId Id of item_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptions: function (itemTypeId, options) {
            return localVarFp.getOptions(itemTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all parameter type by ID from the database
         * @summary Finds all parameter_type by ID
         * @param {object} parameterTypeId The ID of the parameter type to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameterType: function (parameterTypeId, options) {
            return localVarFp.getParameterType(parameterTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all units relating to the specified unit_type_id within the database. Units are grouped by their unit system.
         * @summary Finds a unit type\'s corresponding units
         * @param {object} unitTypeId Unique ID for a single unit type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitType: function (unitTypeId, options) {
            return localVarFp.getUnitType(unitTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update an existing asset type. Note - requires Admin privileges.
         * @summary Patch an existing asset type (Application Admin only)
         * @param {object} assetTypeId The ID of the asset type to search
         * @param {PatchAssetTypeBody} patchAssetTypeBody Updates for the asset type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAssetType: function (assetTypeId, patchAssetTypeBody, options) {
            return localVarFp.patchAssetType(assetTypeId, patchAssetTypeBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update an existing parameter type. Note - updating global parameter types (scope = null) requires Admin privileges.
         * @summary Patch existing parameter type
         * @param {object} parameterTypeId The ID of the parameter type to search
         * @param {PatchParameterTypeBody} patchParameterTypeBody Updates for parameter type. Note - updating the default unit  will also update the associated unit type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchParameterType: function (parameterTypeId, patchParameterTypeBody, options) {
            return localVarFp.patchParameterType(parameterTypeId, patchParameterTypeBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates new asset sub types. Note - requires Admin privileges.
         * @summary Creates new asset sub types (Application Admin only)
         * @param {object} assetTypeId Asset_type_ids to search by
         * @param {PostAssetSubTypesBody} postAssetSubTypesBody New asset sub type details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssetSubTypes: function (assetTypeId, postAssetSubTypesBody, options) {
            return localVarFp.postAssetSubTypes(assetTypeId, postAssetSubTypesBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates an asset type group. Note - requires Admin privileges.
         * @summary Create a new asset type group (Application Admin only)
         * @param {PostAssetTypeGroupsBody} postAssetTypeGroupsBody New asset type details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssetTypeGroups: function (postAssetTypeGroupsBody, options) {
            return localVarFp.postAssetTypeGroups(postAssetTypeGroupsBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates an asset type. Note - requires Admin privileges.
         * @summary Create a new asset type (Application Admin only)
         * @param {PostAssetTypesBody} postAssetTypesBody New asset type details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssetTypes: function (postAssetTypesBody, options) {
            return localVarFp.postAssetTypes(postAssetTypesBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates an item type.  Note - creating a global item type requires Admin privileges.
         * @summary Create a new item type
         * @param {PostItemTypesBody} postItemTypesBody New item type details. You must specify the asset_type_id if posting  with an asset_sub_type_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postItemTypes: function (postItemTypesBody, options) {
            return localVarFp.postItemTypes(postItemTypesBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates new parameter types. Note - creating global parameter types (scope = null) requires Admin privileges.
         * @summary Creates new parameter types
         * @param {PostParameterTypesBody} postParameterTypesBody New parameter type details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postParameterTypes: function (postParameterTypesBody, options) {
            return localVarFp.postParameterTypes(postParameterTypesBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Posts new unit types. This can only be done by an administrator
         * @summary Create new units types. Note - requires Admin privileges.
         * @param {PostUnitTypesBody} postUnitTypesBody Unit types to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUnitTypes: function (postUnitTypesBody, options) {
            return localVarFp.postUnitTypes(postUnitTypesBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Posts new units. This can only be done by an administrator
         * @summary Create new units. Note - requires Admin privileges.
         * @param {PostUnitsBody} postUnitsBody Units to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUnits: function (postUnitsBody, options) {
            return localVarFp.postUnits(postUnitsBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Overwrites options for a given item_type by deleting the existing and adding new
         * @summary Sets options for given item_type - Note - creating options for a global item type requires Admin privileges.
         * @param {object} itemTypeId Id of item_type
         * @param {PutOptionsRequest} putOptionsRequest List of values (each value is an object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOptions: function (itemTypeId, putOptionsRequest, options) {
            return localVarFp.putOptions(itemTypeId, putOptionsRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TaxonomyApiFactory = TaxonomyApiFactory;
/**
 * TaxonomyApi - object-oriented interface
 * @export
 * @class TaxonomyApi
 * @extends {BaseAPI}
 */
var TaxonomyApi = /** @class */ (function (_super) {
    __extends(TaxonomyApi, _super);
    function TaxonomyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete an item type from the database by id. Note - deleting a global item type requires Admin privileges.
     * @summary Soft delete item type by id
     * @param {TaxonomyApiDeleteItemTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.deleteItemType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).deleteItemType(requestParameters.itemTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Soft-deletes options of the given item_type
     * @summary Deletes options for given item_type - Note - deleting options for a global item type requires Admin privileges.
     * @param {TaxonomyApiDeleteOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.deleteOptions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).deleteOptions(requestParameters.itemTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all asset type groups contained within the database
     * @summary Finds all asset_type_groups within the database
     * @param {TaxonomyApiGetAllAssetTypeGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.getAllAssetTypeGroups = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TaxonomyApiFp)(this.configuration).getAllAssetTypeGroups(requestParameters.assetTypeGroupId, requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all asset types contained within the database
     * @summary Finds all asset_types within the database
     * @param {TaxonomyApiGetAllAssetTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.getAllAssetTypes = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TaxonomyApiFp)(this.configuration).getAllAssetTypes(requestParameters.projectId, requestParameters.assetTypeId, requestParameters.parentAssetId, requestParameters.assetTypeGroupId, requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all item types
     * @summary Get all item types
     * @param {TaxonomyApiGetAllItemTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.getAllItemTypes = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TaxonomyApiFp)(this.configuration).getAllItemTypes(requestParameters.itemTypeId, requestParameters.parameterTypeId, requestParameters.assetTypeId, requestParameters.notAssetTypeId, requestParameters.assetSubTypeId, requestParameters.notAssetSubTypeId, requestParameters.showGlobal, requestParameters.showLocal, requestParameters.scopeId, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.sortBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all parameter types contained within the database
     * @summary Finds all parameter_types within the database
     * @param {TaxonomyApiGetAllParameterTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.getAllParameterTypes = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TaxonomyApiFp)(this.configuration).getAllParameterTypes(requestParameters.notAssetId, requestParameters.projectId, requestParameters.notProjectId, requestParameters.assetTypeId, requestParameters.assetSubTypeId, requestParameters.parameterTypeId, requestParameters.showGlobal, requestParameters.showLocal, requestParameters.scopeId, requestParameters.sortBy, requestParameters.assetId, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all units systems contained within the database. Unit systems are unique by name.
     * @summary Finds all unit systems within the database
     * @param {TaxonomyApiGetAllUnitSystemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.getAllUnitSystems = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TaxonomyApiFp)(this.configuration).getAllUnitSystems(requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all units types contained within the database. Unit types are unique by name. Note - the available unit types for a parameter type should be obtained from the parameter_types endpoint.
     * @summary Finds all unit types within the database
     * @param {TaxonomyApiGetAllUnitTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.getAllUnitTypes = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TaxonomyApiFp)(this.configuration).getAllUnitTypes(requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.unitTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all units contained within the database. Units are unique by name. Note - the available units for a parameter type should be obtained from the parameter_types endpoint.
     * @summary Finds all units within the database
     * @param {TaxonomyApiGetAllUnitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.getAllUnits = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TaxonomyApiFp)(this.configuration).getAllUnits(requestParameters.parameterTypeId, requestParameters.sortBy, requestParameters.assetId, requestParameters.projectId, requestParameters.unitId, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all asset sub types related to the specified asset type contained within the database
     * @summary Finds all asset_sub_types related to the asset_type_id
     * @param {TaxonomyApiGetAssetSubTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.getAssetSubTypes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).getAssetSubTypes(requestParameters.assetTypeId, requestParameters.assetSubTypeId, requestParameters.parentAssetSubTypeId, requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all id, name, asset_type_id, and parent_asset_sub_type_id of  asset sub types related to the specified asset sub type ids contained within the database
     * @summary Finds all asset_sub_types associated with provided asset_sub_type_id
     * @param {TaxonomyApiGetAssetSubTypesRefRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.getAssetSubTypesRef = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TaxonomyApiFp)(this.configuration).getAssetSubTypesRef(requestParameters.assetSubTypeId, requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns parent, children, grandchildren etc. asset types contained within the database
     * @summary Gets an asset type tree by asset_type_id within the database
     * @param {TaxonomyApiGetAssetTypeTreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.getAssetTypeTree = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).getAssetTypeTree(requestParameters.assetTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Lists all options for an item type
     * @summary Get all options for an item type
     * @param {TaxonomyApiGetOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.getOptions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).getOptions(requestParameters.itemTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all parameter type by ID from the database
     * @summary Finds all parameter_type by ID
     * @param {TaxonomyApiGetParameterTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.getParameterType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).getParameterType(requestParameters.parameterTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all units relating to the specified unit_type_id within the database. Units are grouped by their unit system.
     * @summary Finds a unit type\'s corresponding units
     * @param {TaxonomyApiGetUnitTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.getUnitType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).getUnitType(requestParameters.unitTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update an existing asset type. Note - requires Admin privileges.
     * @summary Patch an existing asset type (Application Admin only)
     * @param {TaxonomyApiPatchAssetTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.patchAssetType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).patchAssetType(requestParameters.assetTypeId, requestParameters.patchAssetTypeBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update an existing parameter type. Note - updating global parameter types (scope = null) requires Admin privileges.
     * @summary Patch existing parameter type
     * @param {TaxonomyApiPatchParameterTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.patchParameterType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).patchParameterType(requestParameters.parameterTypeId, requestParameters.patchParameterTypeBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates new asset sub types. Note - requires Admin privileges.
     * @summary Creates new asset sub types (Application Admin only)
     * @param {TaxonomyApiPostAssetSubTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.postAssetSubTypes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).postAssetSubTypes(requestParameters.assetTypeId, requestParameters.postAssetSubTypesBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates an asset type group. Note - requires Admin privileges.
     * @summary Create a new asset type group (Application Admin only)
     * @param {TaxonomyApiPostAssetTypeGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.postAssetTypeGroups = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).postAssetTypeGroups(requestParameters.postAssetTypeGroupsBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates an asset type. Note - requires Admin privileges.
     * @summary Create a new asset type (Application Admin only)
     * @param {TaxonomyApiPostAssetTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.postAssetTypes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).postAssetTypes(requestParameters.postAssetTypesBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates an item type.  Note - creating a global item type requires Admin privileges.
     * @summary Create a new item type
     * @param {TaxonomyApiPostItemTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.postItemTypes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).postItemTypes(requestParameters.postItemTypesBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates new parameter types. Note - creating global parameter types (scope = null) requires Admin privileges.
     * @summary Creates new parameter types
     * @param {TaxonomyApiPostParameterTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.postParameterTypes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).postParameterTypes(requestParameters.postParameterTypesBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Posts new unit types. This can only be done by an administrator
     * @summary Create new units types. Note - requires Admin privileges.
     * @param {TaxonomyApiPostUnitTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.postUnitTypes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).postUnitTypes(requestParameters.postUnitTypesBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Posts new units. This can only be done by an administrator
     * @summary Create new units. Note - requires Admin privileges.
     * @param {TaxonomyApiPostUnitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.postUnits = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).postUnits(requestParameters.postUnitsBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Overwrites options for a given item_type by deleting the existing and adding new
     * @summary Sets options for given item_type - Note - creating options for a global item type requires Admin privileges.
     * @param {TaxonomyApiPutOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    TaxonomyApi.prototype.putOptions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TaxonomyApiFp)(this.configuration).putOptions(requestParameters.itemTypeId, requestParameters.putOptionsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TaxonomyApi;
}(base_1.BaseAPI));
exports.TaxonomyApi = TaxonomyApi;
